import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import Form from "../components/Form";
import { fetchJob } from "../features/job/jobSlice";

export default function EditJob() {
  const dispatch = useDispatch();
  const { jobsId } = useParams();
  useEffect(() => {
    dispatch(fetchJob(jobsId));
  }, [dispatch, jobsId]);

  return <Form editmode />;
}
